// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"b000a0e8","873":"4abc708d","876":"912ba16b","952":"180a14ac"}[chunkId] + ".chunk.css";
};